import { render, staticRenderFns } from "./MemberSlackIdChange.vue?vue&type=template&id=543e45e5"
import script from "./MemberSlackIdChange.vue?vue&type=script&lang=js"
export * from "./MemberSlackIdChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports